export enum Breakpoints {
  Small = 768,
  Medium = 1024,
  Large = 1280,
  Max = 1920,
}

/**
 * @deprecated Prefer var(--breakpoints-below-small)
 */
export const BelowSmall = `(max-width: ${Breakpoints.Small - 1}px)`;
/**
 * @deprecated Prefer var(--breakpoints-below-medium)
 */
export const BelowMedium = `(max-width: ${Breakpoints.Medium - 1}px)`;
/**
 * @deprecated Prefer var(--breakpoints-below-large)
 */
export const BelowLarge = `(max-width: ${Breakpoints.Large - 1}px)`;

/**
 * @deprecated Prefer var(--breakpoints-small-and-above)
 */
export const SmallAndAbove = `(min-width: ${Breakpoints.Small}px)`;
/**
 * @deprecated Prefer var(--breakpoints-medium-and-above)
 */
export const MediumAndAbove = `(min-width: ${Breakpoints.Medium}px)`;
/**
 * @deprecated Prefer var(--breakpoints-large-and-above)
 */
export const LargeAndAbove = `(min-width: ${Breakpoints.Large}px)`;

/**
 * @deprecated Prefer var(--breakpoints-media-below-small)
 */
export const MediaBelowSmall = `@media ${BelowSmall}`;
/**
 * @deprecated Prefer var(--breakpoints-media-below-medium)
 */
export const MediaBelowMedium = `@media ${BelowMedium}`;
/**
 * @deprecated Prefer var(--breakpoints-media-below-large)
 */
export const MediaBelowLarge = `@media ${BelowLarge}`;

/**
 * @deprecated Prefer var(--breakpoints-media-small-and-above)
 */
export const MediaSmallAndAbove = `@media ${SmallAndAbove}`;
/**
 * @deprecated Prefer var(--breakpoints-media-medium-and-above)
 */
export const MediaMediumAndAbove = `@media ${MediumAndAbove}`;
/**
 * @deprecated Prefer var(--breakpoints-media-large-and-above)
 */
export const MediaLargeAndAbove = `@media ${LargeAndAbove}`;
/**
 * @deprecated Prefer var(--breakpoints-media-medium-and-above)
 */
export const MediaDesktop = MediaMediumAndAbove; // just an alias
